import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { fontSize } = typographyStyles;
const neutral600 = colors.ui.neutral[600];
const neutral700 = colors.ui.neutral[500];

export const loadingCss = {
  borderRadius: "8px",
  backgroundColor: "#eee",
  marginTop: "1em",
  padding: "1.5em 1em",
  textAlign: "center",
};

export const headerCss = {
  display: "flex",
  marginTop: "2em",
  alignItems: "center",
  justifyContent: "space-between",
};

export const headingCss = {
  color: neutral600,
  ...fontSize.textS,
  fontWeight: "bold",
  margin: "0",
};

export const disclaimerCss = {
  marginTop: "1em",
  color: neutral700,
  ...fontSize.textS,
};

export const generatedPromptCss = {
  width: "100%",
  marginTop: "0.5em",
  lineHeight: 1.5,
  textAlign: "left",
};

export const refreshButtonCss = {
  padding: "8px",
};
